import {
  getInvoiceItemCategoriesAsync,
  getInvoiceItemCategoryDetailAsync,
  saveInvoiceItemCategoryAsync,
  getDivisionsAsync,
} from "./InvoiceItemCategoriesReducer";
import { put, takeLatest } from "redux-saga/effects";
import {
  postInvoiceItemCategoriesGetList,
  getInvoiceItemCategoriesGetDetail,
  postInvoiceItemCategoriesSave,
  getInvoiceItemCategoriesGetDivisions,
} from "Api/Api";
import { getType } from "typesafe-actions";
import { call } from "typed-redux-saga";
import { toast } from "react-toastify";
import i18next from "i18next";
import { getResourcePath, Resources } from "Translations/Resources";

function* getInvoiceItemCategories(
  action: ReturnType<typeof getInvoiceItemCategoriesAsync.request>,
): Generator {
  try {
    const response = yield* call(
      postInvoiceItemCategoriesGetList,
      action.payload,
    );
    if (response.status === 200) {
      yield put(getInvoiceItemCategoriesAsync.success(response.json));
    } else {
      yield put(getInvoiceItemCategoriesAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getInvoiceItemCategoriesAsync.failure(err));
  }
}
export function* getInvoiceItemCategoriesSaga() {
  yield takeLatest(
    getType(getInvoiceItemCategoriesAsync.request),
    getInvoiceItemCategories,
  );
}

function* getInvoiceItemCategoryDetail(
  action: ReturnType<typeof getInvoiceItemCategoryDetailAsync.request>,
): Generator {
  try {
    const response = yield* call(
      getInvoiceItemCategoriesGetDetail,
      action.payload,
    );
    if (response.status === 200) {
      yield put(getInvoiceItemCategoryDetailAsync.success(response.json));
    } else {
      yield put(getInvoiceItemCategoryDetailAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getInvoiceItemCategoryDetailAsync.failure(err));
  }
}
export function* getInvoiceItemCategoryDetailSaga() {
  yield takeLatest(
    getType(getInvoiceItemCategoryDetailAsync.request),
    getInvoiceItemCategoryDetail,
  );
}

function* saveInvoiceItemCategory(
  action: ReturnType<typeof saveInvoiceItemCategoryAsync.request>,
): Generator {
  try {
    const response = yield* call(postInvoiceItemCategoriesSave, action.payload);
    if (response.status === 200) {
      if (response.json.isValid) {
        toast.success(
          i18next.t(
            getResourcePath(Resources.InvoiceItemCategories.Detail.SaveSuccess),
          ),
        );
      } else {
        toast.error(
          i18next.t(
            response.json.validationErrors
              ? response.json.validationErrors[0].message
              : getResourcePath(
                  Resources.InvoiceItemCategories.Detail.SaveFail,
                ),
          ),
        );
      }
      yield put(saveInvoiceItemCategoryAsync.success(response.json));
    } else {
      toast.error(
        i18next.t(
          getResourcePath(Resources.InvoiceItemCategories.Detail.SaveFail),
        ),
      );
      yield put(saveInvoiceItemCategoryAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(saveInvoiceItemCategoryAsync.failure(err));
  }
}
export function* saveInvoiceItemCategorySaga() {
  yield takeLatest(
    getType(saveInvoiceItemCategoryAsync.request),
    saveInvoiceItemCategory,
  );
}

function* getDivisions(): Generator {
  try {
    const response = yield* call(getInvoiceItemCategoriesGetDivisions);
    if (response.status === 200) {
      yield put(getDivisionsAsync.success(response.json));
    } else {
      yield put(getDivisionsAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getDivisionsAsync.failure(err));
  }
}
export function* getDivisionsSaga() {
  yield takeLatest(getType(getDivisionsAsync.request), getDivisions);
}
